import React from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  ListItemSecondaryAction,
  Divider,
  Link
} from "@material-ui/core";
import { LocalLibrary } from "@material-ui/icons";
import db from "../db.js";
const data = db();
const manuals = data.manuals;

class Manuals extends React.Component {

  componentDidMount() {
    document.title = "GO | Manuales";
  }

  render() {

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginBottom: 25 }}>
            <Typography variant="h5">
              Manuales disponibles
            </Typography>
            <List component="nav">
            {
              manuals.map((manual) => {
              return(
                <React.Fragment key={manual.name}>
                  <Link href={manual.url} color="inherit" target="_blank">
                    <ListItem key={manual.name}>
                      <ListItemIcon>
                        <LocalLibrary/>
                      </ListItemIcon>
                      <ListItemText
                        primary={manual.name}
                        secondary={manual.desc}
                        >
                      </ListItemText>
                      <ListItemSecondaryAction>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider />
                  </Link>
                </React.Fragment>
                )
              })
            }
            </List>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default Manuals;



// WEBPACK FOOTER //
// ./src/components/Manuals.js